import "./Landingfold.css";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import landingContext from "../../../context/landing/landingcontext";
import contactContext from "../../../context/contact/contactcontext";

function Landingfold() {
  const { landingContent } = useContext(landingContext);
  const { contactInfo } = useContext(contactContext);

  const phone = contactInfo.phone ? JSON.parse(contactInfo.phone) : { phone: "080 2334 7276" };

  return (
    <section className="hero" id="home">
      <div className="wrap">
        <div className="hero-grid">
          <div className="hero-copy">
            <p className="eyebrow">Malleswaram, Bangalore &middot; Since 2011</p>
            <h1>Best Maternity Hospital in Bangalore for Normal Delivery</h1>
            <p className="lede">
              At Lakshmi Maternity &amp; Surgical Centre, we pride ourselves in providing safe and natural childbirth for the well-being of both mother and child. Since 2011, the trusted name in maternity hospitals in Bangalore has witnessed the birth of over 105,000 healthy babies. Founded by Dr. Leela Rao and led by Dr. Mahesh and Dr. Nishita Rao we have now become the best maternity hospital in bangalore for normal delivery. With 24/7 availability, excellent facilities, and higher success rates for normal delivery, we promise to make your birth experience safe and comfortable with memories to cherish. Because at Lakshmi, you will find love and support every step of your pregnancy.
            </p>
            <div className="hero-cta">
              <Link className="btn-solid" to="/appointment">
                Book an appointment
              </Link>
              <a className="btn-ghost" href={`tel:${phone.phone ? phone.phone.replace(/\s+/g, '') : "08023347276"}`}>
                Call {phone.phone || "080 2334 7276"}
              </a>
            </div>
            <p className="hero-note">
              Labour and delivery support is available 24 hours a day, every day of the year, with epidural options for painless delivery.
            </p>
          </div>

          <figure className="hero-fig">
            <div className="frame">
              <img
                src="/img/uplaods/mother-loves-her-child.avif"
                alt="Safe normal delivery care at Lakshmi Maternity Bangalore"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/img/uplaods/landing.webp";
                }}
              />
            </div>
            <figcaption className="hero-badge">
              <strong>1,05,000+</strong>
              <span>Healthy babies delivered</span>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}

export default Landingfold;